import React from "react";
import classes from "./WhatsApp.module.css";

const WhatsApp = () => {
  return (
    <a
      href="https://wa.me/66887608734"
      className={classes.whatsappFloat}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <span className={classes.waText}>Chat on WhatsApp</span>
      <span className={classes.waIcon}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
        <path d="M16 3C9.4 3 4 8.4 4 15c0 2.5.8 4.8 2.1 6.7L4 29l7.4-2c1.8 1 3.9 1.6 6.1 1.6 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 22c-1.9 0-3.8-.5-5.4-1.5l-.4-.2-4 1 1-4-.3-.4C6.5 18 6 16.5 6 15c0-5.5 4.5-10 10-10s10 4.5 10 10-4.5 10-10 10zm5.6-7.3c-.3-.2-1.9-1-2.3-1.1-.3-.1-.5-.2-.7.1s-.8 1.1-1 1.3c-.2.2-.4.3-.7.1-.3-.2-1.4-.5-2.7-1.6-1-.9-1.7-2-1.9-2.3-.2-.3 0-.5.1-.7.1-.1.3-.4.5-.6.2-.2.2-.3.3-.6s.1-.4 0-.6c0-.1-.7-1.8-1-2.4-.3-.6-.5-.6-.7-.6-.2 0-.4 0-.6 0-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.2 1.3 3.4c.2.2 2.3 3.6 5.6 5 2.8 1.2 3.2.8 3.8.7.6-.1 2-.8 2.2-1.6.2-.8.2-1.4.2-1.6 0-.1-.3-.2-.6-.4z"/>
      </svg>
      </span>
    </a>
  );
};

export default WhatsApp;
